import VacancyPreview from './VacancyPreview.page';

export default VacancyPreview;